// Importing necessary utilities for styling
import {
  transition,
} from "../../material-dashboard-react";

// Defining styles for the admin layout
const appStyle = theme => ({
  // Wrapper styles
  wrapper: {
    position: "relative", // Relative positioning
    top: "0", // Top position
    height: "100%", // Full height
    backgroundColor: "#F9FAFF", // Background color
  },
  // Main panel styles
  mainPanel: {
    overflow: "auto", // Enable scrolling
    position: "relative", // Relative positioning
    float: "right", // Float to the right
    ...transition, // Smooth transitions
    maxHeight: "100%", // Maximum height
    width: "81%", // Panel width
    overflowScrolling: "touch", // Smooth scrolling
  },
  // Main panel styles when hidden
  mainPanelHide: {
    position: "relative", // Relative positioning
    ...transition, // Smooth transitions
    maxHeight: "100%", // Maximum height
    [theme.breakpoints.up("sm")]: {
      width: "100%", // Full width for small screens
    },
    [theme.breakpoints.up("md")]: {
      width: "93.5%", // Adjusted width for medium screens
      float: "right", // Float to the right
    },
    overflowScrolling: "touch", // Smooth scrolling
  },
  // Content styles
  content: {
    [theme.breakpoints.up("sm")]: {
      marginTop: "77px", // Top margin for small screens
    },
    [theme.breakpoints.up("md")]: {
      marginTop: "77px", // Top margin for medium screens
    },
  },
  // Container styles
  container: {
    [theme.breakpoints.up("md")]: {
      paddingRight: "15px", // Right padding
      paddingLeft: "15px", // Left padding
      marginRight: "auto", // Auto right margin
      marginLeft: "auto", // Auto left margin
    },
    [theme.breakpoints.down("sm")]: {
      paddingTop: "74px", // Top padding for small screens
    },
    [theme.breakpoints.down("xs")]: {
      paddingTop: "74px", // Top padding for extra small screens
    },
  },
  // Map styles
  map: {
    marginTop: "70px", // Top margin
  },
});

export default appStyle;
